// North & Pearl PDP Measurement
// Tracks engagement with details sections for conversion optimization

(function() {
  'use strict';

  // Track when "Details to Know" section comes into view
  function trackDetailsVisibility() {
    const detailsSection = document.querySelector('.np-pdp-quick-details');
    if (!detailsSection || !window.gtag) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // User scrolled to details section
          window.gtag('event', 'np_pdp_details_viewed', {
            event_category: 'pdp_engagement',
            event_label: 'quick_details_section',
            product_id: document.querySelector('[data-product-id]')?.dataset.productId || 'unknown',
            scroll_depth: 'details_section'
          });

          // Stop observing after first view
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 }); // Trigger when 50% visible

    observer.observe(detailsSection);
  }

  // Track "Details to Know" label clicks if it becomes interactive
  function trackDetailsEngagement() {
    const detailsList = document.querySelector('.np-pdp-quick-details__list');
    if (!detailsList || !window.gtag) return;

    // Track if users scroll within details section (indicates reading)
    let scrolled = false;
    detailsList.addEventListener('scroll', () => {
      if (!scrolled) {
        scrolled = true;
        window.gtag('event', 'np_pdp_details_scrolled', {
          event_category: 'pdp_engagement',
          event_label: 'quick_details_section',
          product_id: document.querySelector('[data-product-id]')?.dataset.productId || 'unknown'
        });
      }
    }, { once: true });
  }

  // Initialize tracking when GA4 is ready
  if (window.gtag) {
    // Check if gtag is already loaded
    trackDetailsVisibility();
    trackDetailsEngagement();
  } else {
    // Wait for gtag to load
    window.addEventListener('load', () => {
      setTimeout(() => {
        trackDetailsVisibility();
        trackDetailsEngagement();
      }, 100);
    });
  }
})();
